import { Product, ProductCode } from '@/data/enums';
import { useRoute } from '@/data/hooks';
import { NS_HEADER } from '@/i18n/namespaces';
import { useTranslation } from 'react-i18next';

export const useProductCode = () => {
  const { product } = useRoute();

  return {
    [Product.EasyHealth]: ProductCode.EasyHealth,
    [Product.EzyMedical]: ProductCode.EzyMedical,
    [Product.iMedicalCard]: ProductCode.iMedicalCard,
  }[product];
};

export const useProductName = () => {
  const { product } = useRoute();
  const { t } = useTranslation(NS_HEADER);

  return {
    [Product.EasyHealth]: t('gabTitle'),
    [Product.EzyMedical]: t('insuranceTitle'),
    [Product.iMedicalCard]: t('takafulTitle'),
  }[product];
};
